const setting = {
    url: 'https://apis.africalangues.com'
}

export default setting;
